import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/rdsap/shared/shared.module';
import { IndexedDBService, Setting } from 'src/rdsap/services/configuration/indexeddb.service';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-settings-screen',
  templateUrl: './settings-screen.component.html',
  styleUrls: ['./settings-screen.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, SharedModule]
})

export class SettingsScreenComponent implements OnInit {
  username: string = '';
  password: string = '';
  environment: string = '';
  savePhotos: string = '';
  devModeOnOff: string = 'Off';
  environmentOptions: string[] = ['Live', 'Dev', 'Test'];
  savePhotosOptions: string[] = ['Yes', 'No'];
  devModeOnOffOptions: string [] = ['Off', 'On'];
  settingId: number;

  constructor(private indexedDbService: IndexedDBService) {}

  ngOnInit() {
    this.loadSettings();
  }

  isMobile(): any { 
    console.log(Capacitor.getPlatform());
    console.log(Capacitor.isNativePlatform());
  }

  onSaveDetails(): void { 
    this.saveSettings(); 
  }

  saveSettings() { 
    const setting: Setting = { 
      username: this.username, 
      password: this.password, 
      environment: this.environment || '', 
      savePhotos: this.savePhotos || '', 
      lastloginDate: new Date() 
    }; 
    this.indexedDbService.getSettingByUsername(this.username).subscribe(existingSetting => {
      if (existingSetting && this.settingId) { 
        this.indexedDbService.updateSetting(this.settingId, setting).subscribe(() => { 
          this.loadSettings(); 
        }); 
      } else { 
        this.indexedDbService.addSetting(setting).subscribe((id) => { 
          this.settingId = id; 
          this.loadSettings(); 
        }); 
      } 
    });
  }

  private loadSettings() {
    this.indexedDbService.getRecentSetting().subscribe(setting => {
      if(setting) {
        this.settingId = setting.id;
        this.username = setting.username;
        this.password = setting.password;
        this.environment = setting.environment;
        this.savePhotos = setting.savePhotos;
      }
    });
  }
}